module.exports = __webpack_public_path__ + "static/img/FranciscoAndino.4326f36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/team/FranciscoAndino.jpg
// module id = TK7V
// module chunks = 1